import { useCallback } from 'react';

import { MetrikaGoal, useMetrika } from '../../hooks';
import { PromptDto } from '../../components/types';
import { shareUrl } from '../../utils/share';

export const usePromptShare = (prompt?: PromptDto) => {
    const { reachGoal } = useMetrika();

    const handler = useCallback(async () => {
        if (!prompt) {
            return;
        }

        const { title, description } = prompt;

        const result = await shareUrl({
            title,
            text: description,
            url: window.location.href,
        });

        if (result.success) {
            reachGoal(MetrikaGoal.ClickSharePrompt);
        }

        return result;
    }, [prompt, reachGoal]);

    return handler;
};
